import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Footer from "./Footer";
const Termsandcondition = () => {
  return (
    <>
      <div style={{ overflowX: "hidden", width: "100%" }}>
  
      <div
        style={{
          background: "linear-gradient(135deg, #0e9bff, #3ac8ff)",
          padding: "13px 0",
          color: "white",
          textAlign: "center",
          fontWeight: "600",
          letterSpacing: ".5px",
        }}
      >
        <span style={{ fontSize: "1.2rem" }}>
          ⚡ Get Instant Loan Approval with us — Apply Now!
        </span>
      </div>
      <div className="row d-flex justify-content-center">
        <div className="col-9">
          <div className="card-body p-4 p-md-5">
            <h1 className="mb-4 text-center fw-bold">Terms &amp; Conditions</h1>

            <h5 className="fw-semibold mb-3">
              Shubhpaisa Finance Private Limited
            </h5>

            <p>
              Welcome to ShubhPaisa Finance Private Limited ("we", "our", "us").
              By accessing, browsing, or using our services, including our
              website, mobile applications, and any other digital platforms
              (collectively referred to as the "Platform"), you acknowledge that
              you have read, understood, and agree to comply with the following
              Terms and Conditions ("Terms").
            </p>

            <p>
              These Terms govern your use of our services and set forth the
              rules and guidelines for accessing and interacting with our
              Platform. By accessing the Platform or using our services, you
              agree to be bound by these Terms, our Privacy Policy, and any
              other applicable policies. If you do not agree with any part of
              these Terms, please refrain from using our Platform and services.
            </p>

            <p>
              ShubhPaisa Finance Private Limited offers a variety of financial
              services, including personal loans, loan processing services,
              financial consultation, and related products. Please note that the
              services are subject to eligibility criteria, approval processes,
              and specific terms associated with each product. We reserve the
              right to update, amend, or modify these Terms at any time, and any
              such changes will be effective upon posting on this page. You are
              encouraged to review these Terms periodically for any updates.
            </p>

            <hr />

            <h4 className="mt-4">Eligibility</h4>
            <p>
              To access and use the services provided by Shubhpaisa Finance
              Private Limited, you must be at least 18 years of age. By
              registering or using our services, you confirm that you are
              legally competent and authorized to enter into a binding contract
              under the laws applicable in India. You also affirm that you are
              not disqualified from availing financial services under any
              prevailing laws, regulations, or court orders. The Company
              reserves the right to refuse access or terminate services if it is
              discovered that you do not meet the eligibility criteria or have
              provided false information.
            </p>

            <hr />

            <h4 className="mt-4">Services Offered</h4>
            <p>
              Shubhpaisa Finance Private Limited is a financial services company
              engaged in providing a range of credit and lending solutions to
              individuals and businesses. Our core services include, but are not
              limited to, personal loans, business loans, EMI financing, credit
              line services, and other consumer credit products. These offerings
              are designed to help customers meet their short-term and long-term
              financial needs, with flexible repayment options, transparent
              terms, and a simplified digital application process.
            </p>

            <p>
              We strive to deliver financial products that are accessible,
              affordable, and aligned with each customer’s unique financial
              profile and creditworthiness. All loan approvals and disbursals
              are subject to internal eligibility criteria, regulatory
              guidelines, and verification procedures, including credit checks
              and KYC compliance.
              <br />
              In addition to lending, the Company may offer related financial
              advisory, credit score insights, and tools to help customers make
              informed decisions.
            </p>

            <p>
              Shubhpaisa Finance Private Limited reserves the right to modify,
              enhance, suspend, or permanently discontinue any of its services,
              either in part or in full, at its sole discretion and without
              prior notice. Such changes may occur due to regulatory updates,
              business requirements, or strategic decisions. Continued use of
              the Services implies acceptance of such modifications.
            </p>

            <hr />

            <h4 className="mt-4">User Responsibilities</h4>
            <p>
              By using the services of Shubhpaisa Finance Private Limited, you
              agree to adhere to all applicable laws, rules, and regulations, as
              well as these Terms and Conditions. You are responsible for
              providing accurate, complete, and up-to-date information during
              registration, application, and throughout your use of our
              services. Any false, misleading, or outdated information may
              result in denial of service, loan rejection, or legal action.
            </p>

            <p>
              You must maintain the confidentiality of your account credentials,
              including your username, password, and any authentication details.
              You are solely responsible for all activities carried out under
              your account. In case of any unauthorized use or suspected breach,
              you must notify us immediately.
            </p>

            <p>
              You are expected to use our financial services ethically, repay
              loans on time, and fulfill any obligations as per the agreed loan
              terms. Failure to do so may impact your credit score and result in
              recovery action.
              <br />
              The Company reserves the right to take appropriate measures if any
              misuse or violation of responsibilities is detected.
            </p>

            <hr />

            <h4 className="mt-4">Loan Terms</h4>
            <ol className="mt-3">
              <li className="mb-3">
                <strong>
                  Loan approval is subject to credit assessment and
                  verification:
                </strong>{" "}
                Loan approval through Shubhpaisa Finance Private Limited is not
                automatic and is strictly subject to a thorough credit
                assessment and verification process. This involves evaluating
                your creditworthiness based on factors such as your credit
                score, income stability, repayment history, employment details,
                and other financial obligations. We may also request supporting
                documents to validate your identity, address, and income. The
                Company reserves the right to accept or reject any loan
                application at its sole discretion. Submission of an application
                does not guarantee loan approval, and all decisions will be
                communicated to the applicant after the evaluation is complete.
              </li>

              <li className="mb-3">
                <strong>
                  Interest rates, tenure, and repayment terms will be clearly
                  communicated prior to disbursal:
                </strong>{" "}
                Before your loan is disbursed, Shubhpaisa Finance Private
                Limited will clearly communicate all relevant details regarding
                the interest rates, loan tenure, and repayment terms. This
                includes the exact interest rate applicable to your loan, the
                duration of the repayment period, and the schedule for monthly
                or periodic repayments. Additionally, any processing fees,
                prepayment charges, or other applicable costs will be disclosed.
                You will have the opportunity to review all terms and conditions
                associated with your loan before accepting the offer. Proceeding
                with the loan disbursal implies your understanding and
                acceptance of these terms.
              </li>

              <li className="mb-3">
                <strong>
                  Late payments or defaults may attract penalties and affect
                  your credit score:
                </strong>{" "}
                Late payments or defaults on your loan may result in penalties,
                including late fees and additional charges as outlined in your
                loan agreement. These penalties will be applied if payments are
                not made by the due date. Moreover, failing to make timely
                payments can significantly impact your credit score and your
                ability to secure future loans, as we report payment history to
                credit bureaus. Continued default may also lead to further
                collection efforts, legal actions, or other consequences as
                permitted by law. It is crucial to make repayments as agreed to
                avoid these negative outcomes.
              </li>
            </ol>

            <hr />

            <h4 className="mt-4">Privacy Policy</h4>
            <p>
              Your privacy is of utmost importance to Shubhpaisa Finance Private
              Limited. We are committed to protecting your personal data and
              ensuring that your information is handled responsibly. Our Privacy
              Policy outlines how we collect, store, use, and safeguard your
              personal information, including details you provide during account
              registration, loan applications, and any other interactions with
              our services. We also explain how we may share your data with
              third parties, in accordance with legal requirements or for
              service improvement purposes. Please review our full Privacy
              Policy for a comprehensive understanding of our data protection
              practices.
            </p>

            <hr />

            <h4 className="mt-4">Intellectual Property</h4>
            <p>
              All intellectual property rights in the content, materials, and
              technology used on this platform—including, but not limited to,
              the design, layout, text, graphics, logos, images, audio, video,
              software, and source code—are the exclusive property of Shubhpaisa
              Finance Private Limited or its licensors, and are protected by
              applicable copyright, trademark, and intellectual property laws.
            </p>

            <p>
              You are granted a limited, non-exclusive, non-transferable right
              to access and use the platform solely for your personal or
              internal business use. You may not copy, reproduce, modify,
              republish, upload, post, display, encode, translate, transmit, or
              distribute any part of the platform or its content in any form or
              by any means, including mirroring to other websites or servers,
              without the prior written consent of Shubhpaisa Finance Private
              Limited.
            </p>

            <hr />

            <h4 className="mt-4">Limitation of Liability</h4>
            <p>
              While we strive to provide accurate and reliable financial
              services, Shubhpaisa Finance Private Limited is not responsible
              for any losses or damages you may suffer from using our platform.
              This includes things like financial loss, technical issues, or
              interruptions in service.
            </p>
            <p>
              The platform will always work perfectly or that the information
              provided will always be 100% up to date. If you're unhappy with
              our services, the best solution is to stop using them.
            </p>
            <hr />

            <h4 className="mt-4">Termination</h4>
            <p>
              Shubhpaisa Finance Private Limited reserves the right to suspend
              or terminate your access to its services at any time, with or
              without notice, for reasons including but not limited to breach of
              terms, submission of false information, misuse of services, or as
              required by law or regulatory authorities. You may terminate your
              use of the services by notifying us in writing and clearing all
              outstanding obligations. Upon termination, your access will be
              revoked, but any pending dues or liabilities shall remain
              enforceable. Certain provisions, including those related to
              liability and dispute resolution, shall survive termination.
            </p>

            <hr />

            <h4 className="mt-4">Governing Law &amp; Jurisdiction</h4>
            <p>
              These Terms & Conditions shall be governed by and interpreted in
              accordance with the laws of India, without regard to its conflict
              of law provisions. Any disputes, claims, or controversies arising
              out of or relating to these Terms, your use of our services, or
              any agreement with Shubhpaisa Finance Private Limited shall be
              subject to the exclusive jurisdiction of the competent courts
              located in India. By using our services, you expressly consent to
              the jurisdiction of such courts and waive any objection based on
              venue, inconvenience of forum, or any similar grounds.
            </p>

            <hr />

            <h4 className="mt-4">Contact Us</h4>
            <p className="mb-1">
              <strong>Shubhpaisa Finance Private Limited</strong>
            </p>
            <p className="mb-0">Email:  customercare@subhpaisa.com</p>
          </div>
        </div>
      </div>
      <Footer />
      </div>
    </>
  );
};

export default Termsandcondition;
